import React, { useState, useEffect } from 'react';

import './styles.css';

import bankAccountServices from '../../../../services/admFin/bankAccountServices';
import formatterBR, { formatter } from '../../../../functions/formatCurrency';
import compare from '../../../../functions/compare';

import Popup from '../../../../components/Popup';
import PopupBillPayment from './PopupBillPayment';
import ListInfos from '../../../../components/ListInfos';
import InstallmentItem from './InstallmentItem';
import { FaArrowUp, FaArrowDown, FaFileInvoiceDollar } from 'react-icons/fa';

export default function PopupBill(props) {
    const [bill, setBill] = useState({});
    const [popupBillPaymentVisible, setPopupBillPaymentVisible] = useState(false);
    let auxDate = new Date();
    let formatterCurrency = bill.moeda && bill.moeda !== "BRL" ? formatter(bill.moeda) : formatterBR;

    useEffect(() => {
        if (props.data) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            auxDate = new Date();
            auxDate.setHours(auxDate.getHours() - (auxDate.getTimezoneOffset() / 60));
            setBill(props.data);
        }
    }, [props.data]);

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            id="bill"
            icon={<FaArrowUp />}
            tittle={`Conta a Pagar`}
        >
            {
                bill.id ?
                    <>
                        <div className="bill-infos">
                            <div className="tittle">
                                <h4><b>{bill.descricao}</b></h4>
                                {
                                    auxDate.toISOString().slice(0, 10) > bill.data_venc && !bill.paga ?
                                        <span className='tag red'>ATRASADA</span>
                                        : null
                                }
                            </div>

                            <hr />

                            {bill.colaborador ? <p><b>Colaborador:</b> {bill.colaborador.nome}</p> : null}
                            {bill.empresa ? <p><b>Empresa:</b> {bill.empresa.nome}</p> : null}
                            <hr />

                            {bill.conta_bancaria ? <p><b>Conta bancária:</b> {bankAccountServices.formatBankAccount(bill.conta_bancaria)}</p> : null}
                            {bill.forma_de_pagamento ? <p><b>Forma de pag.:</b> {bill.forma_de_pagamento.nome}</p> : null}

                            <hr />

                            {bill.id ? <p><b>Total pago:</b> {formatterCurrency.format(bill.valor_pago)}</p> : null}
                            {bill.numero_parcelas ? <p><b>Parcelas totais:</b> {bill.numero_parcelas}</p> : null}
                            {bill.numero_parcelas_pagas !== undefined ? <p><b>Parcelas pagas:</b> {bill.numero_parcelas_pagas}</p> : null}
                            {bill.data_venc ? <p><b>Próximo vencimento:</b> {bill.data_venc.split('-').reverse().join('/')}</p> : null}
                            {/* <p><b>Data de pagamento:</b> {bill.data_pag ? bill.data_pag.split('-').reverse().join('/') : "Não pago"}</p> */}
                            {
                                bill.obs ?
                                    <span className='tag large strong dark-blue'>{bill.obs}</span>
                                    : null
                            }
                        </div>


                        {
                            bill.parcelas.length ?
                                <>
                                    <ListInfos
                                        tittle="Pagamento"
                                        counter={bill.parcelas.length}
                                        counterName="parcelas"
                                        singleCounterName="parcela"
                                    />

                                    <ul className={'list' + (bill.parcelas.length >= 2 ? " group" : "")}>
                                        {
                                            bill.parcelas.sort((a, b) => compare(a.data_venc, b.data_venc)).map((item, index) =>
                                                <InstallmentItem
                                                    key={item.id}
                                                    index={index}
                                                    payed={item.paga}
                                                    isLate={auxDate.toISOString().slice(0, 10) > item.data_venc}
                                                    dueDate={item.data_venc}
                                                    payDate={item.data_pag}
                                                    value={formatterCurrency.format(item.valor)}
                                                />
                                            )
                                        }
                                    </ul>
                                </>
                                : null

                        }

                        <div className="line">
                            <button onClick={() => props.editBill(bill)}>Editar</button>

                            <>
                                {
                                    !bill.paga ?
                                        <button className="green" onClick={() => setPopupBillPaymentVisible(true)}>Pagar</button>
                                        : []
                                }
                                <PopupBillPayment
                                    visibility={popupBillPaymentVisible}
                                    setVisibility={setPopupBillPaymentVisible}
                                    data={bill}
                                    onRegisterPayment={props.onEdit}
                                />
                            </>
                        </div>
                    </>
                    : []
            }
        </Popup >
    )
}